import React, { Component } from "react";

class Header extends Component {
    onChange = (key) => (e) => {
        if (e.target) {
            this.setState({ [key]: e.target.value });
        } else this.setState({ [key]: e });
    };

    render() {

        return (
            <>
                {/* <div className="bl-header">
                    <div className="bl-header-title">
                        <h3>Latest Local RankFlux score</h3>
                    </div>
                </div> */}
            </>
        );
    }
}

export default Header;
